import React, { useState } from 'react';
import Loading from 'components/commons/loading/Loading';
import Modal from 'components/commons/modal/Modal2';
import { UpdateAccountSymbolAvailableResult } from 'config/api';

export const ChangeAggregatedModal = ({
  hide,
  isShow,
  setIsAggregated,
  updateAccountSymbolAvailable,
}: {
  isShow: boolean;
  hide: () => void;
  setIsAggregated: React.Dispatch<React.SetStateAction<boolean>>;
  updateAccountSymbolAvailable: () => Promise<
    UpdateAccountSymbolAvailableResult
  >;
}): React.ReactElement => {
  const [isUpdating, setIsUpdating] = useState<boolean>(false);

  const change = async (): Promise<void> => {
    if (isUpdating) return;

    setIsUpdating(true);

    const result = await updateAccountSymbolAvailable();
    if (result.Success) setIsAggregated(prev => !prev);

    setIsUpdating(false);
    hide();
  };

  const hideModal = () => {
    if (!isUpdating) return hide();
  };

  return (
    <>
      <Modal {...{ isShow: isShow, close: hide }}>
        <div className="px-4 py-8">
          <div className="flex mb-3 justify-center">
            <div className="font-bold">ご確認ください</div>
          </div>
          <div>
            <div>
              集計対象を変更すると、資産総額が変わる可能性がありますので、変更の際はご注意ください。
            </div>
            <br />
            <div>資産総額への反映にはお時間がかかる可能性があります。</div>
            <div>
              <div
                className="ui-btn mt-4 py-3 flex flex-col items-center cursor-pointer"
                onClick={() => change()}>
                {isUpdating ? (
                  <Loading
                    loading={isUpdating}
                    circularLoading
                    style={{ width: '45px', height: '27px' }}
                  />
                ) : (
                  <>変更する</>
                )}
              </div>
              <div
                className="mt-4 text-center cursor-pointer"
                onClick={(): void => hideModal()}>
                キャンセル
              </div>
            </div>
          </div>
        </div>
      </Modal>
    </>
  );
};
